import { createPromiseClient } from '@bufbuild/connect';
import { LmsConnectedClassAPIServiceV3 } from '@protos/learning_management/lms.connected.apis_connect';

import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';
import { ConnectTransportOptions } from '@bufbuild/connect-web';

const LmsConnectedClassAPIServiceV3Client = createPromiseClient(
  LmsConnectedClassAPIServiceV3,
  lmsTransport
);

export const useLmsConnectedClassAPIServiceV3ClientWithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    LmsConnectedClassAPIServiceV3,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
